import {
    afterRenderEffect,
    Directive,
    ElementRef,
    inject,
    input,
} from '@angular/core';

/** Keep the mounted editor inert during verification and restore its keyboard position. */
@Directive({
    selector: '[qpxBuildingAccessRegion]',
    host: {
        '[hidden]': 'blocked()',
        '[attr.inert]': 'blocked() ? "" : null',
        '(focusin)': 'rememberFocus($event)',
        '(focusout)': 'forgetDepartedFocus($event)',
    },
})
export class BuildingAccessRegion {
    readonly blocked = input.required<boolean>({
        alias: 'qpxBuildingAccessRegion',
    });
    private readonly element =
        inject<ElementRef<HTMLElement>>(ElementRef).nativeElement;
    private previous: HTMLElement | null = null;
    private wasBlocked = false;

    constructor() {
        afterRenderEffect(() => {
            const blocked = this.blocked();
            if (this.wasBlocked && !blocked && this.previous) {
                const target =
                    this.previous.isConnected &&
                    !this.previous.matches(':disabled')
                        ? this.previous
                        : this.element;
                queueMicrotask(() => {
                    if (!this.blocked() && target.isConnected) target.focus();
                });
            }
            this.wasBlocked = blocked;
        });
    }

    protected rememberFocus(event: FocusEvent): void {
        if (!this.blocked() && event.target instanceof HTMLElement)
            this.previous = event.target;
    }
    protected forgetDepartedFocus(event: FocusEvent): void {
        if (
            !this.blocked() &&
            event.relatedTarget instanceof Node &&
            !this.element.contains(event.relatedTarget)
        )
            this.previous = null;
    }
}
